import React from "react";
import { FiAlertCircle, FiCheckCircle, FiInfo, FiX } from "react-icons/fi";
import { ToastType, useToastStore } from "./store";
import S from "./styles.module.scss";

const icons: Record<ToastType, typeof FiInfo> = {
  success: FiCheckCircle,
  error: FiAlertCircle,
  info: FiInfo,
};

const Toaster = () => {
  const toasts = useToastStore((state) => state.toasts);
  const dismiss = useToastStore((state) => state.dismiss);

  if (!toasts.length) return null;

  return (
    <div className={S.container} role="status" aria-live="polite">
      {toasts.map((toast) => {
        const Icon = icons[toast.type];
        return (
          <div key={toast.id} className={`${S.toast} ${S[toast.type]}`}>
            <Icon size={18} className={S.icon} />
            <span className={S.message}>{toast.message}</span>
            <button
              type="button"
              className={S.close}
              onClick={() => dismiss(toast.id)}
              aria-label="Fechar notificação"
            >
              <FiX size={14} />
            </button>
          </div>
        );
      })}
    </div>
  );
};

export default Toaster;

